<div class="section-head" *ngIf="title || subtitle">
  <h2 *ngIf="title">{{ title | translate }}</h2>
  <p *ngIf="subtitle" class="desc keep-resp">{{ subtitle | translate }}</p>
</div>
